import React, { Component } from "react";
import { truncateText, formatTime, apiUrl } from "../util";
import { Link } from "react-router-dom";
import request from "request";
import StarIcon from "../icons/star_solo.svg";
import BlueStarIcon from "../icons/blue_star.svg";
import GoldStarIcon from "../icons/star_gold.svg";
import SplitQueueControl from "../components/SplitQueueControl";
class VolumeSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
    };
  }
  handleChange = e => {
    this.props.callback(e.currentTarget.value, this.props.type);
  };
  render() {
    const { selected, type } = this.props;
    return (
      <select
        name={`volume_${type}`}
        defaultValue={selected}
        onChange={this.handleChange}
      >
        <option value="low">10</option>
        <option value="high">50</option>
      </select>
    );
  }
}
class PrioritySelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null,
    };
  }
  handleChange = e => {
    this.props.callback(e.currentTarget.value, "priority");
  };
  render() {
    const { selected } = this.props;
    return (
      <select
        name="priority"
        defaultValue={selected}
        onChange={this.handleChange}
      >
        <option value="normal">normal priority</option>
        <option value="low">low priority</option>
        <option value="discontinued">not tracking</option>
      </select>
    );
  }
}
class Urls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      urls: [],
      showOnlyHigh: false,
      showOnlyLow: false,
      showOnlyFlagged: false,
      filterByText: false,
      urlsToAdd: "",
      loading: true,
    };
  }
  getData = () => {
    const { token } = this.state;
    request(
      {
        url: `${apiUrl}/v1/admin/v2/getTrackedUrls${
          token ? `?token=${token}` : ""
        }`,
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        const json = JSON.parse(data);
        this.setState({
          urls: json.urls,
          loading: false,
        });
      }
    );
  };
  componentDidMount() {
    request(
      {
        url: `${apiUrl}/v1/admin/v2/getTrackedUrls`,
        headers: {
          Authorization: this.props.user.token,
        },
      },
      (err, res, data) => {
        const json = JSON.parse(data);
        this.setState({
          urls: json.urls,
          loading: false,
        });
      }
    );
  }
  showOnlyHigh = e => {
    e.preventDefault();
    document.getElementById("search").value = "";
    this.setState({
      showOnlyHigh: true,
      showOnlyLow: false,
      showOnlyFlagged: false,
      filterByText: false,
    });
  };
  showOnlyFlagged = e => {
    e.preventDefault();
    document.getElementById("search").value = "";
    this.setState({
      showOnlyHigh: false,
      showOnlyLow: false,
      showOnlyFlagged: true,
      filterByText: false,
    });
  };
  showOnlyLow = e => {
    e.preventDefault();
    document.getElementById("search").value = "";
    this.setState({
      showOnlyHigh: false,
      showOnlyLow: true,
      showOnlyFlagged: false,
      filterByText: false,
    });
  };
  filterTextBy = e => {
    const val = e.currentTarget.value;
    if (val.length > 2) {
      this.setState({
        showOnlyHigh: false,
        showOnlyLow: false,
        showOnlyFlagged: false,
        loading: true,
      });

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.setState({ token: val }, () => {
          this.getData();
        });
      }, 200);
    } else {
      this.clear();
    }
  };
  timeout = null;
  clear = e => {
    if (e) {
      e.preventDefault();
      document.getElementById("search").value = "";
    }
    this.setState({
      showOnlyHigh: false,
      showOnlyLow: false,
      filterByText: false,
    });
  };
  deleteUrl = url => {
    if (window.confirm(`Sure you want to delete ${url}?`)) {
      this.setState({
        loading: true,
      });
      request.post(
        {
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            Authorization: this.props.user.token,
          },
          url: `${apiUrl}/v1/admin/v2/deleteTrackedUrl`,
          form: { url },
        },
        err => {
          if (!err) {
            this.getData();
          }
        }
      );
    }
  };
  editUrl = url => {
    return (value, type) => {
      this.setState({
        loading: true,
      });
      const urlInfo = this.state.urls.find(urlItem => {
        if (urlItem.url === url) {
          return true;
        } else {
          return false;
        }
      });
      if (type === "override") {
        urlInfo.manual_override = false;
      } else if (type === "flag") {
        if (urlInfo.flag === "true") {
          urlInfo.flag = false;
        } else {
          urlInfo.flag = true;
        }
      } else if (type === "priority") {
        urlInfo.priority = value;
      } else {
        urlInfo[`${type}_volume`] = value;
        urlInfo.manual_override = true;
      }
      request.post(
        {
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            Authorization: this.props.user.token,
          },
          url: `${apiUrl}/v1/admin/v2/editTrackedUrl`,
          form: urlInfo,
        },
        err => {
          if (!err) {
            this.getData();
          }
        }
      );
    };
  };
  addUrls = e => {
    e.preventDefault();
    this.setState({
      loading: true,
    });
    request.post(
      {
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.props.user.token,
        },
        url: `${apiUrl}/v1/admin/v2/addTrackedUrls`,
        form: { urls: this.state.urlsToAdd.join(",") },
      },
      (err, res, data) => {
        this.setState({
          urlsToAdd: null,
        });
        document.getElementById("urls").value = "";
        const json = JSON.parse(data);
        if (!err && json.added) {
          this.getData();
        }
      }
    );
  };
  handleUrlChange = e => {
    const vals = e.currentTarget.value.split("\n");
    this.setState({
      urlsToAdd: vals.map(val => val.trim()),
    });
  };
  render() {
    const {
      urls,
      showOnlyHigh,
      showOnlyLow,
      showOnlyFlagged,
      filterByText,
      loading,
    } = this.state;

    urls.sort((a, b) =>
      `${a.domain}${a.url.split("/").slice(3).join("")}` >
      `${b.domain}${b.url.split("/").slice(3).join("")}`
        ? 1
        : -1
    );
    let filteredUrls = urls;

    if (showOnlyHigh) {
      filteredUrls = urls.filter(
        url => url.desktop_volume === "high" || url.mobile_volume === "high"
      );
    } else if (showOnlyLow) {
      filteredUrls = urls.filter(
        url => url.desktop_volume === "low" || url.mobile_volume === "low"
      );
    } else if (filterByText) {
      filteredUrls = urls.filter(url => url.url.indexOf(filterByText) > -1);
    } else if (showOnlyFlagged) {
      filteredUrls = urls.filter(
        url => url.flag === true || url.flag === "true"
      );
    }
    const disabledStyle = loading ? { opacity: 0.4 } : {};
    return (
      <div disabled={loading} style={disabledStyle}>
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }}>
            <p>
              <b>Show only: </b>
              <a href={showOnlyHigh ? null : "#"} onClick={this.showOnlyHigh}>
                high-volume
              </a>{" "}
              &middot;{" "}
              <a href={showOnlyLow ? null : "#"} onClick={this.showOnlyLow}>
                low-volume
              </a>{" "}
              &middot;{" "}
              <a
                href={showOnlyFlagged ? null : "#"}
                onClick={this.showOnlyFlagged}
              >
                flagged
              </a>
            </p>
            <p>
              <input
                type="text"
                onChange={this.filterTextBy}
                id="search"
                placeholder="Search..."
              />
            </p>
            {(showOnlyHigh || showOnlyLow || filterByText) && (
              <p>
                <a href="#" onClick={this.clear}>
                  Show All
                </a>
              </p>
            )}
          </div>
          <div>
            <form
              style={{ marginBottom: "2em" }}
              onSubmit={this.addUrls}
              disabled={this.state.loading}
            >
              <label>Add URLs</label>
              <br />
              <textarea
                name="urls"
                id="urls"
                onChange={this.handleUrlChange}
                style={{ width: "300px", height: "100px" }}
              />
              <div style={{ textAlign: "right" }}>
                <input type="submit" value="Add" />
              </div>
            </form>
          </div>
        </div>
        {filteredUrls.map(url => {
          return (
            <div style={{ marginBottom: "1em", display: "flex" }} key={url.url}>
              <div title={url.url} style={{ flexGrow: 1 }}>
                {truncateText(url.url.replace(/https?:\/\//gi, ""), 60)}{" "}
                <Link to={`/screens/${encodeURIComponent(url.url)}`}>🔗</Link>
                {(url.desktop_volume === "high" ||
                  url.mobile_volume === "high") && <span>✅</span>}
                {(url.desktop_flagged || url.mobile_flagged) && <span>⚠️</span>}
                {(url.split_end_mobile || url.split_end_desktop) && (
                  <span>👑</span>
                )}
                {url.split_end_mobile && <span>📱</span>}
                {url.split_end_desktop && <span>💻</span>}
                {url.priorityCompany && (
                  <img src={StarIcon} alt="Priority Company" className="ph1" />
                )}
                {url.regularPriority && (
                  <img
                    src={BlueStarIcon}
                    alt="Regular Priority Company"
                    className="ph1"
                  />
                )}
                {url.competitoralertPriority && (
                  <img
                    src={GoldStarIcon}
                    alt="Competitor Alert Priority"
                    className="ph1"
                  />
                )}
              </div>
              <div>
                <PrioritySelect
                  selected={url.priority || "normal"}
                  callback={this.editUrl(url.url)}
                />{" "}
                <label>
                  <input
                    type="checkbox"
                    checked={url.flag === "true"}
                    onChange={e => {
                      this.editUrl(url.url)(null, "flag");
                    }}
                  />{" "}
                  Flag{" "}
                </label>{" "}
                💻
                <VolumeSelect
                  type="desktop"
                  selected={url.desktop_volume}
                  callback={this.editUrl(url.url)}
                />{" "}
                📱
                <VolumeSelect
                  type="mobile"
                  selected={url.mobile_volume}
                  callback={this.editUrl(url.url)}
                />
                <SplitQueueControl
                  compact
                  user={this.props.user}
                  url={url.url}
                  trackedUrl={url}
                />
                {url.manual_override === true && (
                  <span>
                    <b>Overridden</b>{" "}
                    <a
                      href="#"
                      onClick={e => {
                        e.preventDefault();
                        this.editUrl(url.url)(null, "override");
                      }}
                    >
                      remove override
                    </a>
                  </span>
                )}{" "}
                <a
                  onClick={() => {
                    this.deleteUrl(url.url);
                  }}
                  style={{ cursor: "pointer" }}
                  title="Delete this url"
                >
                  ❌
                </a>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

export default Urls;
